//angular imports
import {
    ChangeDetectionStrategy,
    Component, 
    WritableSignal, 
    signal,
} from '@angular/core';

//local imports
import { PresenterType } from '@shared/components';
import { ProgramAddedMessage } from './program-added.message';

@PresenterType(
{
    model: ProgramAddedMessage
})
@Component({
    selector: 'program-added-message-template',
    templateUrl: './program-added-message-template.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ProgramAddedMessageTemplateComponent
{
    public data: WritableSignal<ProgramAddedMessage>;
    
    constructor() {
        this.data = signal<ProgramAddedMessage>(null);
    }
}